// INR + timezone helpers
export function inr(n) {
  const v = Number(n || 0);
  return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function numIN(n) {
  return Number(n || 0).toLocaleString("en-IN");
}

export const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata";

// parse ISO safely: strings without a timezone marker are UTC (backend stores UTC)
function parseUTC(iso) {
  let s = String(iso);
  if (/^\d{4}-\d{2}-\d{2}T[\d:.]+(Z|[+-]\d{2}:?\d{2})?$/.test(s) && !/(Z|[+-]\d{2}:?\d{2})$/.test(s)) {
    s += "Z";
  }
  return new Date(s);
}

export function fmtDateTime(iso, tz = userTZ) {
  if (!iso) return "—";
  try {
    return parseUTC(iso).toLocaleString("en-IN", {
      timeZone: tz,
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return new Date(iso).toLocaleString();
  }
}

export function fmtDate(iso, tz = userTZ) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      timeZone: tz,
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

// today as YYYY-MM-DD in the user's local timezone
export function todayLocal() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function prettyDay(ymd) {
  if (!ymd) return "—";
  const [y, m, d] = ymd.split("-");
  return new Date(y, m - 1, d).toLocaleDateString("en-IN", { weekday: "short", day: "2-digit", month: "short" });
}

// --- date format helpers (DD-MM-YYYY <-> YYYY-MM-DD) ---
export function dmyToYmd(dmy) {
  if (!dmy) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(dmy)) return dmy;
  const m = dmy.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
}

export function ymdToDmy(ymd) {
  if (!ymd) return "";
  const m = ymd.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
}

// Precise Indian number-to-words (Indian digit grouping: crore/lakh/thousand/hundred).
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
  "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function twoDigitWords(n) {
  if (n < 20) return ONES[n];
  return TENS[Math.floor(n / 10)] + (n % 10 ? " " + ONES[n % 10] : "");
}

function threeDigitWords(n) {
  const h = Math.floor(n / 100);
  const r = n % 100;
  let s = h ? ONES[h] + " Hundred" : "";
  if (r) s += (s ? " " : "") + twoDigitWords(r);
  return s;
}

function indianWords(v) {
  if (v === 0) return "";
  const crore = Math.floor(v / 10000000);
  const lakh = Math.floor((v % 10000000) / 100000);
  const thousand = Math.floor((v % 100000) / 1000);
  const rest = v % 1000;
  const parts = [];
  if (crore) parts.push(indianWords(crore) + " Crore"); // recurse for values >= 100 crore
  if (lakh) parts.push(twoDigitWords(lakh) + " Lakh");
  if (thousand) parts.push(twoDigitWords(thousand) + " Thousand");
  if (rest) parts.push(threeDigitWords(rest));
  return parts.join(" ");
}

// 240500 -> "Two Lakh Forty Thousand Five Hundred Rupees"
export function toIndianWords(n) {
  const v = Math.floor(Number(n));
  if (!v || v <= 0 || !isFinite(v)) return "";
  return indianWords(v) + (v === 1 ? " Rupee" : " Rupees");
}
